module.exports = __webpack_public_path__ + "img/47.10.pH.88601dc6.png";